import request from '@/utils/request'

const key = 'store_account'
const key2 = 'store'
// 查询门店列表
export function fetchStoreList(params) {
  return request({
    url: `/platform/${key2}`,
    method: 'get',
    params
  })
}

// 创建门店
export function createStore(data) {
  return request({
    url: `/platform/${key2}`,
    method: 'post',
    data
  })
}

// 编辑门店
export function updateStore(id, data) {
  return request({
    url: `/platform/${key2}/${id}`,
    method: 'post',
    data
  })
}

// 门店详情
export function fetchStoreDetails(id, params) {
  return request({
    url: `/platform/${key2}/${id}`,
    method: 'get',
    params
  })
}

// 更新门店状态
export function updateStoreStatus(id) {
  return request({
    url: `/platform/${key2}/status/${id}`,
    method: 'post',
  })
}

// 获取标签列表
export function fetchTagsList(params) {
  return request({
    url: `/platform/tag`,
    method: 'get',
    params
  })
}

// 创建标签
export function createTags(data) {
  return request({
    url: `/platform/tag`,
    method: 'post',
    data
  })
}
